import { BORDER_VISIBILITY, BPMN_ACTION_TYPE, COLORPIC_CONTEXT , DROPSHADOW_VISIBILITY, FONTSTYLES_VISIBILITY, TEXT_EDITOR_VISIBILITY, SET_BPMN_TARS_VISIBILITY, BACKGROUND_MENU_VISIBILITY, ERROR_FONTSTYLES_VISIBILITY, SET_FUNCTIONS_LIST } from './types'
export function onBpmnAction(data: any) {
    return {
        type: BPMN_ACTION_TYPE,
        data
    };
}

export function onsetDropShadowVisibility(data: any) {
    return {
        type: DROPSHADOW_VISIBILITY,
        data
    }
}

export function onSetBgdMenuVisibility(data: any) {
    return {
        type: BACKGROUND_MENU_VISIBILITY,
        data
    }
}

export function onSetBorderVisibility(data:any) {
    return {
        type: BORDER_VISIBILITY,
        data
    }
}

export function onSetFontStylesVisibility(data:any) {
    return {
        type:FONTSTYLES_VISIBILITY,
        data
    }
}

export function onSetErrorFontStylesVisibility(data:any){
    return {
        type:ERROR_FONTSTYLES_VISIBILITY,
        data
    }
}

export function onSetTextEditorVisibility(data:any) {
    return {
        type:  TEXT_EDITOR_VISIBILITY,
        data
    }
}

export function onsetClrPicContext(data:any) {
    return {
        type: COLORPIC_CONTEXT,
        data
    }
}

export function setBPMNTarsVisibility(visibility: boolean) {
    return {
        data: visibility,
        type: SET_BPMN_TARS_VISIBILITY,
    }
}

export function setFunctions(data:any) {
    return {
        data: data,
        type: SET_FUNCTIONS_LIST,
    }
}

export function logout() {
    return {
        type: 'LOG_OUT',
    }
}
